export const WIDGET_ELEM_someReqPropsUnset = (widgetConfig) => {
  const measureMode = widgetConfig?.props?.measureMode || 'fieldStat';

  // docCount mode: just needs a content type
  if (measureMode === 'docCount') {
    return !widgetConfig?.props?.contentType;
  }

  // fieldStat mode (default)
  const field = widgetConfig?.props?.field;
  const isNumberInput = field?.comp === 'NumberInput';

  // Check basic requirements
  if (!widgetConfig?.props?.contentType || !field) {
    return true;
  }

  // For NumberInput: need statFunction.
  // For categorical fields: contentType + field are sufficient. An empty/missing
  // selectedFieldValue is a valid runtime state — the widget falls back to
  // aggregating over every value in the filter-scoped fieldValueCounts (see
  // selectedOptionsData in ./index.js), so we should NOT trigger the unset
  // placeholder just because no explicit values were picked.
  if (isNumberInput) {
    return !widgetConfig?.props?.statFunction;
  }
  return false;
};
